import React from 'react';
import { isEnglishChars } from '../../utils';
import { getAvatarColor } from '../../utils/persistor';

const Avatar = ({ avatarId, imageUrl, fullName, wrapperClass }) => {
  const fullNameArray = fullName.split(' ');
  const firstChar = fullName[0];
  const secondChar = fullNameArray[1] !== undefined && fullNameArray[1][0];
  const isEnglish = isEnglishChars(firstChar + secondChar);
  const style = {
    direction: isEnglish && 'ltr',
  };
  return (
    <div style={style} className={wrapperClass}>
      {imageUrl && (
        <object
          className='avatarImage'
          data={imageUrl}
          type='image/png'
          title={fullName}
        >
          <div
            className='fallbackIcon'
            title={fullName}
            style={{ backgroundColor: getAvatarColor(avatarId) }}
          >
            <span>{firstChar}</span>
            <span>{secondChar}</span>
          </div>
        </object>
      )}
      {!imageUrl && (
        <div
          className='fallbackIcon emptyUrl'
          title={fullName}
          style={{ backgroundColor: getAvatarColor(avatarId) }}
        >
          <span>{firstChar}</span>
          <span>{secondChar}</span>
        </div>
      )}
    </div>
  );
};

export default Avatar;
